module.exports = "<fleet-page></fleet-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/index.html
// module id = 1316
// module chunks = 0